import { NOTIFICATIONTYPE } from "Store/Notification/ActionTypes";
import { StoreState } from "Store/Reducers";
import { ACTION_TYPE, getActionTypes } from "Store/Shared/Actions/Helpers";
import ACTIONS from "./ActionTypes";

export const fetchEntityTypesByEntityId = (entity_id): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.FETCH_ENTITY_TYPES),
    shouldCallAPI: ({ settings: { entity_types }}: StoreState) => !entity_types.byEntityId?.[entity_id] && entity_types._forceFetch,
    callAPI: {
        url: `/api/settings/entities/${entity_id}/types`
    }
});

export const patchEntityTypeById = (id, body): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.PATCH_ENTITY_TYPES),
    callAPI: {
        method: 'PATCH',
        url: `/api/settings/entities/types/${id}`,
        body: body
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol aangepast',
        [NOTIFICATIONTYPE.ERROR]: 'Aanpassing mislukt'
    }
});